export const DEFAULT_WORKSPACE_FILTER_VALUE = 'All'
